<template>
    <router-view />
</template>

<style>

</style>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'customer-portal',

  components: {
  },

  data: () => ({

  }),
  computed: {
    ...mapGetters('Auth', ['LOGGED_IN']),

  },
  methods: {
    ...mapActions('Auth', ['REQUIRE_LOGIN']),
    ...mapActions('UI', ['SET_PAGE_TITLE', 'SHOW_NAVBARS']),

    refresh(){

    },
  },
  mounted() {
    this.REQUIRE_LOGIN(()=>{
      this.SHOW_NAVBARS();
      this.refresh();
    });
  }
};
</script>
7